import React from "react";

function SearchButton(props) {
    const { gotoSearch } = props;

    const handleClick = () => {
        gotoSearch();
    };
    return (
        <li className="fl display_btn2" onClick={handleClick}>
            <button type="button" className="search"></button>
        </li>
    );
}

export default SearchButton;
